<template>
<div class="chapter">
<div class="inner_page">
<p class="toc-title"><span><a id="page_v">CONTENTS</a></span></p><a id="page_v">
</a><p class="toc-entry"><a id="page_v"><span></span></a><a href="#/xhtml/frontmatter01">Preface</a></p>
<p class="toc-entrya"><span><a href="#/xhtml/chapter001">1.  The Waterbury Origins of <i>Roe</i> v. <i>Wade</i></a></span></p>
<p class="toc-entrya"><span><a href="#/xhtml/chapter002">2.  No Further Service: Connecticut’s Struggle for the Legalization of Birth Control, 1940–1953</a></span></p>
<p class="toc-entrya"><span><a href="#/xhtml/chapter003">3.  One Vote Shy: Estelle Griswold, Fowler Harper, and the U.S. Supreme Court, 1954–1961</a></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter004" title="Link target outside of Sample">4.  Creating the Right to Privacy: Estelle Griswold and the U.S. Supreme Court, 1961–1965</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter005" title="Link target outside of Sample">5.  Lonely Voices: Abortion Reformers and the Origins of Change, 1933–1967</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter006" title="Link target outside of Sample">6.  From Reform to Repeal: The <i>Right</i> to Abortion, 1967–1969</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter007" title="Link target outside of Sample">7.  Into the Courts: <i>Roe, Doe</i>, and the Right to Abortion, 1969–1971</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter008" title="Link target outside of Sample">8.  The Right to Abortion and the U.S. Supreme Court, 1971–1973</span></span></p>
<p class="toc-entrya"><span><span href="#/xhtml/chapter009" title="Link target outside of Sample">9.  Liberty and Sexuality Since <i>Roe</i> v. <i>Wade</i></span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter01" title="Link target outside of Sample">Epilogue</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter02" title="Link target outside of Sample">Afterword</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter03" title="Link target outside of Sample">Acknowledgments</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter04" title="Link target outside of Sample">Acknowledgments (1998)</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/notes1" title="Link target outside of Sample">Notes</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/bibliography" title="Link target outside of Sample">Bibliography</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></span></p>
<p class="toc-entry"><span><span href="#/xhtml/endmatter05" title="Link target outside of Sample">About the Author</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?65dd9ac2